import cookies from "js-cookie";

export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
) => {
  cookies.set(name, value, options);
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const getSubCookieDomain = (): string => {
  const host = window.location.hostname;
  const domainParts = host.split(".");
  domainParts.shift();
  const domain = "." + domainParts.join(".");
  return domain === "." ? "localhost" : domain;
};

export const getRidersSessionIdFromCookie = () => {
  if (window.location.hostname === "localhost") {
    return "local";

  } else if (window.location.hostname === "editor.riders.ai") {
    return getCookie("sessionid");

  } else if (window.location.hostname === "editor-staging.riders.ai") {
    return getCookie("stagingsessionid");
  }
};
